import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Overlay = styled.div<{ $mobileTopOffset?: number }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 200;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10vh 16px 0;
  animation: ${fadeIn} 0.15s ease;

  @media (max-width: 767px) {
    background: transparent;
    padding-top: ${({ $mobileTopOffset }) => $mobileTopOffset ?? 60}px;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  width: 640px;
  max-width: 100%;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.25);
  animation: ${slideDown} 0.15s ease;

  @media (max-width: 767px) {
    border-radius: 0;
    width: 100%;
    max-height: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #eee;
    overflow: visible;
  }
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid #E0E4EA;
  flex-shrink: 0;
`;

export const SearchIconWrap = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
    stroke: #B2BEC3;
  }
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 18px;
  font-weight: 400;
  color: #2D3436;
  background: transparent;
  min-width: 0;

  &::placeholder {
    color: #B2BEC3;
  }
`;

export const RightSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ClearBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: #DFE6E9;
  color: #636E72;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: background 0.12s ease;

  &:hover {
    background: #B2BEC3;
    color: #2D3436;
  }
`;

export const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1.5px solid #DFE6E9;
  background: #F7F8FA;
  color: #8898A9;
  font-size: 11px;
  font-weight: 600;
  font-family: ui-monospace, 'SF Mono', monospace;
  letter-spacing: 0.04em;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;

  &:hover {
    background: #EEF1F5;
    border-color: #B2BEC3;
    color: #636E72;
  }

  @media (max-width: 767px) {
    border: none;
    background: none;
    border-radius: 0;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    color: #3b5bdb;
    padding: 0 4px;

    &:hover {
      background: none;
      border-color: transparent;
      color: #2f4ac7;
    }

    .desktop-label { display: none; }
    .mobile-label { display: inline; }
  }

  .mobile-label { display: none; }
`;

export const ResultsArea = styled.div`
  overflow-y: auto;
  flex: 1;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #DFE6E9;
    border-radius: 3px;
  }

  @media (max-width: 767px) {
    overflow-y: visible;
    max-height: 60vh;
    overflow-y: auto;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #eee;
    background: white;
  }
`;

export const EmptyHint = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: #B2BEC3;
  font-size: 15px;
`;
